import { render, staticRenderFns } from "./searchCity.vue?vue&type=template&id=2a52bd24&scoped=true&"
import script from "./searchCity.vue?vue&type=script&lang=js&"
export * from "./searchCity.vue?vue&type=script&lang=js&"
import style0 from "./searchCity.vue?vue&type=style&index=0&id=2a52bd24&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a52bd24",
  null
  
)

export default component.exports